export const formatItemsCount = (num: number) => {
  if (!num) return 0;

  if (num <= 999) {
    return num;
  }

  const thousands = Math.floor(num / 1000);

  if (thousands > 9) {
    return "9k+";
  }

  return num % 1000 === 0 ? `${thousands}k` : `${thousands}k+`;
};

export const getGuestCartTokenPayloadString = () => {
  //     - add guest_token in get cart api(guest user)
  // - clear guest_token on login
  // - pass token to add to cart api
  const token = localStorage.getItem("guest-cart-token");
  return token ? `?guest_token=${token}` : "";
};

export const setGuestCartToken = (token: string) => {
  localStorage.setItem("guest-cart-token", token);
};

export const removeGuestCartToken = () => {
  localStorage.removeItem("guest-cart-token");
};
